window.BookmakerPromocode = (function () {
    var selectors = {
        promoArea: '[data-promo-id]',
        disableBtn: '.js-disable-generate-btn',
        activeBtn: '.js-active-generate-btn',
        btnArea: '.js-generate-button-area'
    }
    var getSelectorCurrentPromo = function(id) {
        return '[data-promo-id={0}]'.replace('{0}', id);
    }

    var classes = {
        activeBtn: {
            page: 'promocodes-page__generate-button',
            table: 'promocodes-table__generate-button',
            js: 'js-active-generate-btn'
        }
    }
    var getBtnHtml = function(page) {
        return '<a class="button m-faded {0} {1}"></a>'
            .replace('{0}', page ? classes.activeBtn.page : classes.activeBtn.table)
            .replace('{1}', classes.activeBtn.js);
    }

    var generateDefaultText = window.Localization.getString('Scripts_Shared_Modules.BookmakerPromocode_19', 'Сгенерировать');
    var generateSuccessMessage = window.Localization.getString('Scripts_Shared_Modules.BookmakerPromocode_20', 'Генерация успешна');
    var generateCommonMessage = window.Localization.getString('Scripts_Shared_Modules.BookmakerPromocode_21', 'Ошибка генерации');

    var generate = function() {
        var $this = $(this);
        var data = $this.parents(selectors.promoArea).data();

        Ajax.postJson("/promocodes/GenerateBookmakerPromocode", {
            data: {
                promoId: data.promoId,
                isSinglePage: data.isSinglePage
            },
            success: function (resp) {
                var promo = $(getSelectorCurrentPromo(data.promoId));
                if (resp) {
                    var btn = promo.find(selectors.activeBtn);
                    Utils.showTooltipError(btn, resp.error ? resp.error : generateCommonMessage);
                } else {
                    var btn = promo.find(selectors.disableBtn);
                    var text = btn.attr('bb-tool');
                    Utils.showTooltipSuccess(btn, generateSuccessMessage, true);
                    setTimeout(function() { Utils.showTooltipError(btn, text, true); }, 10000);
                }
            }
        });
    }

    var showBtn = function($promo) {
        var $area = $promo.find(selectors.btnArea);
        var disabledBtn = $area.find(selectors.disableBtn);
        if (disabledBtn.length == 0) return;
        $area.empty();

        var btn = $(getBtnHtml($promo.data().isSinglePage.toLowerCase().trim().toLowerCase().trim() == 'true'))
            .text(Localization.getString('Bonuses.Generate', generateDefaultText))
            .click(generate);
        $area.append(btn);
    }

    var checkGenerateBtn = function(){
        var promocodes = $(selectors.promoArea);
        for (var i = 0; i < promocodes.length; i++) {
            var $promo = $(promocodes[i]);
            var data = $promo.data();
            if (data.nextDt === '') continue;
            if(new Date(data.nextDt) <= new Date()) {
                showBtn($promo);
            }
        }
    }

    var init = function () {
        var promocodes = $(selectors.promoArea);
        if (promocodes.length > 0) {
            setInterval(checkGenerateBtn, 1000);

            promocodes.find(selectors.activeBtn).click(generate);
        }
    };

    return {
        init: init
    };
}());
window.BookmakerPromocode.init();